/* eslint import/no-webpack-loader-syntax: off */
import { QueryList } from '../../store';

export const queries: QueryList = {
    name: "StackOverflow DBA",
    queries: []
}
